import React from 'react';
import { useTranslation } from 'react-i18next';
import { Icon } from './shared/Icon';

const BENEFIT_KEYS = [
  { icon: 'banknote', title: 'pos.benefit1Title', body: 'pos.benefit1Body' },
  { icon: 'receipt', title: 'pos.benefit2Title', body: 'pos.benefit2Body' },
  { icon: 'activity', title: 'pos.benefit3Title', body: 'pos.benefit3Body' },
] as const;

/**
 * Marketing-style explainer when the current scope has no Hevo POS baskets.
 * Replaces the short snackbar that used to fire from locked revenue tiles.
 */
export function PosConnectModal({
  onClose,
  multiOutlet = false,
}: {
  onClose: () => void;
  /** True when the active scope is a group / multi-outlet view. */
  multiOutlet?: boolean;
}) {
  const { t } = useTranslation('growth');
  return (
    <>
      <div className="scrim" onClick={onClose} role="presentation" />
      <div
        className="pos-connect-modal"
        role="dialog"
        aria-labelledby="pos-connect-title"
        aria-modal="true"
        data-ftue="pos-connect"
      >
        <div className="pos-connect-aurora" aria-hidden />

        <button
          type="button"
          className="pos-connect-close ghost-btn"
          onClick={onClose}
          aria-label={t('pos.close')}
        >
          <Icon name="close" size={18} />
        </button>

        <div className="pos-connect-hero">
          <div className="pos-connect-head">
            <div className="pos-connect-badge" aria-hidden>
              <Icon name="database" size={18} />
            </div>
            <span className="pos-connect-kicker">
              <span className="pos-connect-brand">aleno</span>
              {t('pos.kicker')}
            </span>
          </div>
          <h2 id="pos-connect-title">
            {t('pos.title')}
          </h2>
          <p>
            {multiOutlet ? t('pos.bodyMulti') : t('pos.bodySingle')}
          </p>
        </div>

        <ul className="pos-connect-benefits">
          {BENEFIT_KEYS.map(b => (
            <li key={b.title}>
              <span className="pos-connect-benefit-ic" aria-hidden>
                <Icon name={b.icon} size={16} />
              </span>
              <div>
                <b>{t(b.title)}</b>
                <span>{t(b.body)}</span>
              </div>
            </li>
          ))}
        </ul>

        <div className="pos-connect-foot">
          <p>
            {t('pos.foot')}
          </p>
          <button type="button" className="pos-connect-cta" onClick={onClose}>
            {t('pos.gotIt')}
          </button>
        </div>
      </div>
    </>
  );
}
